export default __webpack_public_path__ + "static/3_16-9181c07fe401228b570be755b5353beb.png";